import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type BrokerCommission = {
  Id: string
  invoice: string
  material: string
  quantity: number
  discount: number
  grossPrice: number
  percentage: number
  commission: number
  soldToParty: string
  billingDate: string
  materialCode: string
  materialName: string
  soldToPartyId: string
  classification: string
  percentageApplied: number
  salesRepresentative: string
  salesRepresentativeId: string
}

type BrokerCommissionStore = {
  brokerCommissions: BrokerCommission[]
  resetBrokerCommissions: () => void
  setBrokerCommission: (brokerCommission: BrokerCommission[]) => void
  updateBrokerCommissionStored: (brokerCommission: BrokerCommission) => void
  findBrokerCommissionById: (id: string) => BrokerCommission | undefined
}

export const useBrokerCommissionStore = create<BrokerCommissionStore>()(
  persist(
    (set, get) => ({
      brokerCommissions: [],
      resetBrokerCommissions: () => set(() => ({ brokerCommissions: [] })),
      setBrokerCommission: (brokerCommissions: BrokerCommission[]) =>
        set(() => ({ brokerCommissions })),
      findBrokerCommissionById: (id: string) => {
        const { brokerCommissions } = get()
        return brokerCommissions.find(
          (brokerCommission: BrokerCommission) => brokerCommission.Id === id
        )
      },
      updateBrokerCommissionStored: (brokerCommission: BrokerCommission) =>
        set((state) => ({
          brokerCommissions: state.brokerCommissions.map((el) => {
            if (el.Id === brokerCommission.Id) {
              return brokerCommission
            }
            return el
          }),
        })),
    }),
    {
      name: 'broker-commission-storage',
      storage: encryptedStorage(),
    }
  )
)
